import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Checkboard from './Checkboard';

const ENTER = 13;

class Swatch extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.string,
    style: PropTypes.object,
    onHover: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.string,
    focus: PropTypes.bool,
    focusStyle: PropTypes.object
  };

  static defaultProps = {
    focusStyle: {}
  };

  handleClick = (event) => {
    const { onClick, color } = this.props;

    onClick(color, event);
  };

  handleKeyDown = (event) => {
    const { onClick, color } = this.props;

    return event.keyCode === ENTER && onClick(color, event);
  };

  handleHover = (event) => {
    const { color, onHover } = this.props;

    onHover(color, event);
  };

  render() {
    const {
      color,
      style,
      onHover,
      title = color,
      children,
      focus,
      focusStyle = {}
    } = this.props;

    const transparent = color === 'transparent';
    const styles = {
      swatch: {
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none',
        ...style,
        ...(focus ? focusStyle : {})
      }
    };

    const optionalEvents = {};

    if (onHover) {
      optionalEvents.onMouseOver = this.handleHover;
    }

    return (
      <div
        style={styles.swatch}
        onClick={this.handleClick}
        title={title}
        tabIndex={0}
        onKeyDown={this.handleKeyDown}
        {...optionalEvents}
      >
        {children}
        {transparent && (
          <Checkboard
            borderRadius={styles.swatch.borderRadius}
            boxShadow="inset 0 0 0 1px rgba(0,0,0,0.1)"
          />
        )}
      </div>
    );
  }
}

export default Swatch;
